import React from "react";
import {Link, useLocation} from "react-router-dom";
import styled from "styled-components";

const CoordinatorNavContainer = styled.nav`
    background: white;
    padding: 1rem;
    margin-bottom: 2rem;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const NavList = styled.ul`
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: 1rem;
`;

const NavItem = styled.li<{ active: string }>`
    a {
        text-decoration: none;
        color: ${props => props.active === 'true' ? '#1890ff' : '#666'};
        font-weight: ${props => props.active === 'true' ? 'bold' : 'normal'};
        padding: 0.5rem 1rem;
        border-radius: 4px;
        transition: all 0.2s ease;

        &:hover {
            background-color: #f5f5f5;
            color: #1890ff;
        }
    }
`;

const CoordinatorNav = () => {
    const location = useLocation();

    return (
        <CoordinatorNavContainer>
            <NavList>
                <NavItem active={location.pathname === '/coordinator' ? 'true' : 'false'}>
                    <Link to="/coordinator">Home</Link>
                </NavItem>
            </NavList>
        </CoordinatorNavContainer>
    );
};

export default CoordinatorNav;
